import VUZLinearLogo from '@shared/assets/svgs/VUZLinearlogo';
import Icons from '@shared/config/constants/Icons';
import css from '@features/welcome/styles/WelcomeV3.module.css';
import cn from 'classnames';
import React from 'react';

import { SuccessRoundedTick } from '@shared/assets/svgs/SuccessRoundedTick';
import { useWideLayout } from '@shared/hooks/useWideLayout';
import { banners } from '@shared/config/constants/Banners';
import { redirectToStore } from '@shared/utils/general';
import { Header, HeaderTV } from '@shared/ui/header';
import { isIOS, isMacOs } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

interface IWelcomeV3 {
  activationURL: string | null;
}

const WelcomeV3: React.FC<IWelcomeV3> = ({ activationURL }): JSX.Element => {
  const { t } = useTranslation();

  const { isTVLayout } = useWideLayout();

  return (
    <div style={{ height: '100vh' }}>
      {isTVLayout ? <HeaderTV /> : <Header />}
      <div className={css.cover}>
        {!isTVLayout ? (
          <div className={css.linearLogo}>
            <VUZLinearLogo />
          </div>
        ) : null}

        <img
          className={cn(css.mainBanner, isTVLayout ? css.mainBannerWide : '')}
          src={banners.success_subs_background}
          alt="redirect banner"
          onClick={redirectToStore}
        />

        <div className={cn(css.wrapper, isTVLayout ? css.wrapperWide : '')}>
          <div className={css.successIcon}>
            <SuccessRoundedTick />
          </div>

          <div className={css.title}>{t('subscribed_success')}</div>

          <div className={css.description}>{t('largest_library_access')}</div>

          {!isTVLayout ? (
            <>
              <div className={css.downloadVUZTitle}>{t('download_vuz_app')}</div>
              {isIOS || isMacOs ? (
                <a
                  href={
                    activationURL
                      ? activationURL
                      : 'https://apps.apple.com/us/app/360-vuz-live-vr-video-views/id964118383'
                  }
                >
                  <img src={Icons.app_store_confirmation_logo} alt="app store" />
                </a>
              ) : (
                <a
                  href={
                    activationURL
                      ? activationURL
                      : 'https://play.google.com/store/apps/details?id=com.creativeinnovations.mea&hl=en'
                  }
                >
                  <img src={Icons.google_paly_confirmation_logo} alt="google play" />
                </a>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default WelcomeV3;
